
import { BaseVue } from "@newview/base-web";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Highcharts from "highcharts";
import venn from "highcharts/modules/venn"; 
import funnel from "highcharts/modules/funnel";
import highmapS from "highcharts/modules/map";
import oldie from "highcharts/modules/oldie";
import cylinder from "highcharts/modules/cylinder";
import exporting from "highcharts/modules/exporting";
import VueHighcharts from "vue-highcharts";
import loadGantt from "highcharts/modules/gantt.js";
import getBullet from "highcharts/modules/bullet.js";
import highcharts3d from "highcharts/highcharts-3d";
import funnel3d from "highcharts/modules/funnel3d";
import pyramid3d from "highcharts/modules/pyramid3d";
import variable from "highcharts/modules/variable-pie";
import highchartsMore from "highcharts/highcharts-more";
import accessibility from "highcharts/modules/accessibility";
import exportData from "highcharts/modules/export-data";
import solidGauge from "highcharts/modules/solid-gauge"
import seriesLabel from "highcharts/modules/series-label"
loadGantt(Highcharts);
getBullet(Highcharts);
venn(Highcharts);
highcharts3d(Highcharts);
exporting(Highcharts);
funnel(Highcharts);
highmapS(Highcharts);
oldie(Highcharts);
cylinder(Highcharts);
funnel3d(Highcharts);
pyramid3d(Highcharts);
variable(Highcharts);
highchartsMore(Highcharts);
exportData(Highcharts);
accessibility(Highcharts);
solidGauge(Highcharts)
Vue.use(VueHighcharts, { Highcharts });
@Component({
  name: "HighChart",
  components: {},
})
export default class HighChart extends BaseVue {
  @Prop({ default: "default" }) chartType!: String; //图表类型
  @Prop({ default: () => ({}) }) options!: any; //图表配置项
  @Prop ({default:false}) seriesLabel!:Boolean   //是否显示seriesLabel
  chartOptionDefault:any = {}
  chartOption:any = {}
  @Watch("options")
  optionsChange() {
    this.options.chart = Object.assign(this.chartOptionDefault.chart,this.options.chart)
    this.chartOption =  Object.assign(this.chartOptionDefault,this.options)
  }
  mounted() {
    this.chartOptionDefault = {
      chart: {
        type: this.options && this.options.type ? this.options.type : "line",
        backgroundColor: "rgba(0,0,0,0)",
        marginRight:  this.options && this.options.marginRight ? this.options.marginRight : 20,
        options3d:
          this.options && this.options.type == "pie"
            ? {
                enabled:  this.options && this.options.is3D ? true : false,
                alpha: 45,
                beta: 0,
              }
            : {
                enabled:  this.options && this.options.is3D ? true : false,
                alpha: 15,
                beta: 15,
                viewDistance: 25,
                depth: 40,
              },
      },
      colors: ["#47D1D3", "#7BC6FD", "#FED198", "#BAA6E1", "#DD7C7F", "#8D99B3"],
      plotOptions: {
        pie: {
          allowPointSelect: true, //每个扇块能否选中
          cursor: "pointer", //鼠标指针
          depth: 35, //饼图的厚度
          dataLabels: {
            enabled: true, //是否显示饼图的线形tip
          },
        },
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      xAxis: {
        crosshair: true, //配置跟随鼠标或鼠标滑过点时的十字准星线
        labels: {
          style: {
            fontSize: "14px",
          },
        },
        type: "category",
      },
      yAxis: {
        title: {
          text: "%",
        },
      },
      credits: {
        enabled: false,
      },
      exporting:{enabled:false},
    };
    this.getBullet()
    if(this.seriesLabel){
      seriesLabel(Highcharts)
    }    
    Highcharts.setOptions({
      global: {
        // @ts-ignore
        useUTC: false
      }
    });
    this.options.chart = Object.assign(this.chartOptionDefault.chart,this.options.chart)
    this.chartOption =  Object.assign(this.chartOptionDefault,this.options)
    // console.log(this.chartOption)
  }
  getchart(){
    return (this as any).$refs.highchart.chart;
  }
  async getBullet(){
    return (await import("../../../Web/smartsite-web/public/static/bullet.js")).default
  }
}
